<div class="select-container">
    <div [attr.data-testid]="'time-picker'" class="select">
        <select class="select-component" [(ngModel)]="model" (ngModelChange)="onChange($event)" 
                [required]="required" [ngClass]="{'input__invalid': !validate()}" >
            <option *ngFor="let option of options" [value]="option">
                {{option || placeholder}}
            </option>
        </select>
        <mat-icon>expand_more</mat-icon>
    </div>
</div>
